import { useAuth } from '../../hooks/useAuth';
import { membershipHasPermission } from '../../auth/permissions';
import { darkTheme, FONT } from '../../theme/tokens';
import { ConnectionsTable } from './ConnectionsTable';

const t = darkTheme;

// SC-3122 — the connector registry: where the org's data comes from and where it
// goes. A table of connection instances; each row opens its settings. Everyone
// sees the page; what they can see and do on it is gated per permission, not the
// tab.
export function ConnectionsTab() {
  const { membership } = useAuth();
  const canManageDestinations = membershipHasPermission(membership, 'manage_destinations');
  const canViewSources = membershipHasPermission(membership, 'view_sources');

  return (
    <div style={{ padding: '28px 32px', maxWidth: 960, fontFamily: FONT }}>
      <h1 style={{ fontSize: 20, fontWeight: 700, color: t.text, margin: '0 0 4px' }}>
        Connections
      </h1>
      <p style={{ fontSize: 13, color: t.text3, margin: '0 0 20px' }}>
        Where your data comes from, and where it goes.
      </p>
      {!canViewSources && (
        <p style={{ fontSize: 12, color: t.text3, margin: '-8px 0 16px' }}>
          Showing where your data goes. Organization admins can also see where it comes from
          and each connection’s settings.
        </p>
      )}
      <ConnectionsTable
        canManageDestinations={canManageDestinations}
        canViewSources={canViewSources}
      />
    </div>
  );
}
